import AtendimentoIcon from "../icons/AtendimentoIcon";
import GFIcon from "../icons/GFIcon";
import QSCIcon from "../icons/QSCIcon";
import QyonBankIcon from "../icons/QyonBankIcon";
import RadarIcon from "../icons/RadarIcon";
import XMLIcon from "../icons/XMLIcon";
import DashboardIcon from "../icons/DashboardIcon";
import OfxIcon from "../icons/OfxIcon";
import ConectaZapIcon from "../icons/ConectaZapIcon";
import BlogReformaIcon from "../icons/BlogReformaIcon";
import CrmVendasIcon from "../icons/CrmVendasIcon";

const options = {
  InicioIcon: (fill) => {
    let f = "";
    let s = "";
    if (fill === "white") {
      f = "white";
      s = "white";
    } else {
      f = fill;
      s = "white";
    }

    return (
      <svg
        id="uuid-82d36db1-4241-4a5a-960c-0876ce99d9de"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 21.927 20.18167"
        width={20}
        height={20}
        fill={f}
      >
        <defs></defs>
        <g id="uuid-a2e51e26-8d28-448e-b4b0-3fe95d7a866b">
          <path
            id="uuid-97a62a42-bf78-4826-a2de-094b00067e58"
            style={{
              fill: { f },
              stroke: { s },
              strokeLinejoin: "round",
              strokeWidth: "1.6px",
            }}
            class="uuid-4279c02b-e6c0-4d0f-a4ed-3b292b863ac6"
            d="m11.925,1.18768c-.46246-.53102-1.26782-.58661-1.79884-.12415-.04419.03848-.08567.07996-.12415.12415L.75,11.82768h3.827v6.34599c.00056.69455.56346,1.25745,1.258,1.258h10.25699c.69454-.00055,1.25745-.56345,1.258-1.258v-6.34599h3.827L11.925,1.18768Z"
          />
        </g>
      </svg>
    );
  },
  BpoIcon: (fill) => (
    <svg width={20} height={20} viewBox="0 0 22 20" fill={fill}>
      <path
        d="M11.8744 11.0016C11.9662 11.0022 12.0549 11.0029 12.1407 11.0039L12.6232 11.0127L13.0457 11.028C13.1116 11.0312 13.1753 11.0347 13.2371 11.0385L13.5855 11.0663C14.1315 11.1204 14.5156 11.2158 14.9134 11.3806C16.1385 11.8881 17.1119 12.8614 17.6193 14.0866L17.6572 14.1804L17.7255 14.3649L17.7841 14.5502L17.8101 14.6449L17.8557 14.8422L17.8935 15.0546C17.8992 15.0916 17.9046 15.1295 17.9097 15.1684L17.9371 15.4146L17.9585 15.6906L17.9746 16.0021L17.9903 16.5488L17.9991 17.4565L18 19C18 19.5523 17.5522 20 17 20H4.99995C4.44757 20 3.99981 19.5521 3.99995 18.9997L4.00038 17.41L4.00388 16.8592L4.01262 16.3768L4.02795 15.9543C4.03113 15.8884 4.03463 15.8247 4.0385 15.7629L4.06621 15.4145C4.12031 14.8685 4.21579 14.4844 4.38057 14.0866C4.88801 12.8614 5.8614 11.8881 7.08651 11.3806C7.48433 11.2158 7.86843 11.1204 8.41441 11.0663L8.76283 11.0385C8.88638 11.0308 9.01781 11.0245 9.15853 11.0194L9.60994 11.0076L10.1255 11.0016H11.8744ZM4.07504 11.982C4.30786 12.4389 4.15579 12.9908 3.73889 13.268L3.63803 13.327C3.07356 13.6146 2.61461 14.0735 2.32698 14.638L2.29592 14.7014L2.23962 14.833L2.1907 14.9753C2.17557 15.0251 2.16158 15.0776 2.14867 15.1336L2.11304 15.3132C2.10761 15.3452 2.10242 15.3783 2.09747 15.4126L2.07054 15.6341L2.04879 15.8901L2.03174 16.1859L2.01891 16.5267L2.00394 17.3648L2.00084 17.8726L2 19C2 19.5523 1.55228 20 1 20C0.487164 20 0.0644929 19.614 0.00672781 19.1166L0 19L0.000953197 17.8109L0.00789309 16.9823L0.0175363 16.5073L0.0322632 16.0871C0.0351923 16.0212 0.0383715 15.9574 0.0418198 15.8955L0.0658928 15.5455C0.12111 14.8865 0.220594 14.4615 0.397373 14.0447L0.492357 13.8359C0.509312 13.8009 0.526842 13.7656 0.544966 13.7301C1.02433 12.7892 1.78924 12.0243 2.73004 11.5449C3.22212 11.2942 3.8243 11.4899 4.07504 11.982ZM19.2698 11.5449C20.2107 12.0243 20.9756 12.7892 21.455 13.7301L21.5497 13.9251C21.5645 13.9573 21.5788 13.9894 21.5927 14.0215L21.6704 14.2155C21.6824 14.2482 21.6941 14.2811 21.7053 14.3143L21.7677 14.5185C21.7773 14.5535 21.7865 14.589 21.7953 14.6251L21.844 14.8507C21.8589 14.929 21.8723 15.0108 21.8845 15.0968L21.9175 15.3683L21.9437 15.6702L21.972 16.1911L21.9891 16.8085L21.9976 17.5392L21.9999 19C21.9999 19.5523 21.5522 20 20.9999 20C20.4871 20 20.0644 19.614 20.0066 19.1166L19.9999 19L19.9991 17.8726L19.9901 16.918L19.9751 16.3503L19.9602 16.0327L19.9409 15.7575L19.9166 15.5194C19.9121 15.4825 19.9074 15.447 19.9024 15.4126L19.8698 15.2204C19.852 15.1307 19.8319 15.05 19.8092 14.9753L19.7603 14.833L19.704 14.7014C19.694 14.6801 19.6836 14.659 19.673 14.638C19.4173 14.1363 19.0262 13.7179 18.546 13.4291L18.3619 13.327C17.8698 13.0762 17.6741 12.474 17.9249 11.982C18.1756 11.4899 18.7778 11.2942 19.2698 11.5449ZM11.8419 13.0015H10.1599L9.50105 13.0105L9.14005 13.0223L8.83308 13.0394L8.5728 13.0626C8.49301 13.0714 8.41977 13.0813 8.35188 13.0924L8.16297 13.1295L7.99875 13.1747C7.94731 13.1911 7.89875 13.209 7.85187 13.2284C7.11681 13.5328 6.5328 14.1169 6.22833 14.8519C6.20891 14.8988 6.19104 14.9474 6.1746 14.9988L6.12949 15.163L6.09235 15.3519C6.08122 15.4197 6.07132 15.4929 6.06252 15.5727L6.03937 15.8328C6.03603 15.8798 6.03294 15.9288 6.03008 15.9799L6.0157 16.3126L6.00338 16.9221L5.99996 18H16L15.9991 17.4928L15.9914 16.6615L15.9726 16.0377L15.9493 15.6795L15.9286 15.4825L15.9032 15.3127C15.8986 15.2863 15.8937 15.2609 15.8886 15.2362L15.8555 15.0966L15.8166 14.9704L15.7716 14.8519C15.4671 14.1169 14.8831 13.5328 14.148 13.2284C14.1011 13.209 14.0526 13.1911 14.0011 13.1746L13.837 13.1295L13.6481 13.0924C13.5802 13.0813 13.507 13.0714 13.4273 13.0626L13.1672 13.0394L12.8605 13.0223L12.4999 13.0105L11.8419 13.0015ZM11 0C13.4852 0 15.5 2.01472 15.5 4.5C15.5 6.98528 13.4852 9 11 9C8.51467 9 6.49996 6.98528 6.49996 4.5C6.49996 2.01472 8.51467 0 11 0ZM5.82014 1.05524C6.1361 1.50822 6.02503 2.13157 5.57205 2.44753C4.90466 2.91305 4.49996 3.67159 4.49996 4.5C4.49996 5.38752 4.96534 6.1934 5.71227 6.64348C6.18531 6.92852 6.33772 7.54307 6.05268 8.01611C5.76764 8.48916 5.15309 8.64156 4.68004 8.35652C3.33857 7.54819 2.49996 6.096 2.49996 4.5C2.49996 3.01077 3.22978 1.64284 4.42786 0.807153C4.88084 0.491193 5.50418 0.602268 5.82014 1.05524ZM17.5721 0.807153C18.7701 1.64284 19.5 3.01077 19.5 4.5C19.5 5.98921 18.7701 7.3572 17.572 8.19285C17.1191 8.5088 16.4957 8.39771 16.1798 7.94473C15.8638 7.49175 15.9749 6.8684 16.4279 6.55245C17.0952 6.08698 17.5 5.32838 17.5 4.5C17.5 3.67159 17.0953 2.91305 16.4279 2.44753C15.9749 2.13157 15.8638 1.50822 16.1798 1.05524C16.4957 0.602268 17.1191 0.491193 17.5721 0.807153ZM11 2C9.61924 2 8.49996 3.11929 8.49996 4.5C8.49996 5.88072 9.61924 7 11 7C12.3807 7 13.5 5.88072 13.5 4.5C13.5 3.11929 12.3807 2 11 2Z"
        fill={fill}
      />
    </svg>
  ),
  ErpIcon: (fill) => (
    <svg
      id="uuid-f51b24d5-ecdf-4dd3-939c-868a5721af88"
      width={20}
      height={20}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 21.5 21.5"
    >
      <defs></defs>
      <g id="uuid-9cbda34c-cc0c-4f79-9117-15e941fb7126">
        <g>
          <path
            class="uuid-49e28c0f-782b-4e49-b4b8-cb22e1ef28e2"
            d="m15.92462,10.64532c-.32581-.23315-.75964-.43726-1.26819-.61462v-2.8067c.21997.17029.41309.39526.57288.67181.16895.28418.31836.49951.44531.63721.09082.09961.19336.146.32129.146.19629,0,.33496-.05957.43555-.18799.11328-.14502.16895-.33252.16895-.57373,0-.23145-.06152-.47461-.18262-.72217-.125-.25342-.30957-.48828-.54785-.69727-.24121-.21143-.54785-.38281-.91406-.51025-.0932-.03241-.19952-.04883-.29944-.07312v-.24847c0-.41425-.33582-.75-.75-.75v.00195c-.41425,0-.75.33582-.75.75v.18799c-.35681.0553-.68909.14581-.96375.31281-.40674.24854-.71924.58496-.92773,1.00049-.21143.42383-.31885.87891-.31885,1.35352,0,.5293.11279.97803.33594,1.33301.22705.36084.53467.65576.91406.87695.26019.15125.59418.29828.96033.44281v3.26447c-.14917-.06183-.29895-.12311-.41785-.22095-.30518-.25195-.56787-.63037-.78027-1.125-.09082-.21924-.18311-.38574-.2749-.49805-.0376-.0459-.10693-.10693-.27295-.10693-.15088,0-.26904.06396-.37207.20215-.11865.15869-.17627.34814-.17627.57861,0,.38428.10791.77441.32178,1.16016.21191.3833.54883.70898,1.00098.96826.28119.16119.61469.25519.97156.31696v.09576c0,.41425.33575.75.75.75.41418,0,.75-.33575.75-.75v-.09998c.33813-.05975.65143-.14801.91858-.28589.45605-.23535.80566-.58691,1.04004-1.04492.23926-.46875.36035-1.0459.36035-1.71582,0-.42969-.08887-.81543-.26367-1.14551-.17578-.33203-.44043-.62549-.78711-.87354Zm-3.37207-1.57422c-.21582-.22119-.32568-.50439-.32568-.84131,0-.37158.146-.68506.43359-.93164.1452-.12518.31262-.21338.49597-.27313v2.44971c-.23798-.11304-.44769-.2439-.60388-.40363Zm2.59326,5.13281c-.14343.13318-.30792.23187-.48938.30066v-2.74585c.18213.09198.33966.18646.46204.28552.31689.25684.47705.65625.47705,1.18701,0,.36719-.15137.69434-.44971.97266Z"
          />
          <path
            class="uuid-49e28c0f-782b-4e49-b4b8-cb22e1ef28e2"
            d="m4.82104,8.20001h-.00305c-.41418.00165-.7486.33875-.74695.75299v6.85699c0,.41418.33575.75.75.75.41418,0,.75-.33582.75-.75v-6.85999c0-.41425-.33582-.75-.75-.75Z"
          />
          <path
            class="uuid-49e28c0f-782b-4e49-b4b8-cb22e1ef28e2"
            d="m8.78802,4.91602v.00195c-.41418,0-.75.33582-.75.75v10.14301c0,.41425.33582.75.75.75.41425,0,.75-.33575.75-.75V5.66602c0-.41425-.33575-.75-.75-.75Z"
          />
          <path
            class="uuid-49e28c0f-782b-4e49-b4b8-cb22e1ef28e2"
            d="m15.43604,0H6.06403C2.43701,0,0,2.54602,0,6.33502v8.82996c0,3.789,2.43701,6.33502,6.06403,6.33502h9.37201c3.62701,0,6.06396-2.54602,6.06396-6.33502V6.33502c0-3.789-2.43695-6.33502-6.06396-6.33502Zm4.56396,15.16498c0,2.935-1.79095,4.83502-4.56396,4.83502H6.06403c-2.77197,0-4.56403-1.90002-4.56403-4.83502V6.33502C1.5,3.40002,3.29205,1.5,6.06403,1.5h9.37201c2.77301,0,4.56396,1.90002,4.56396,4.83502v8.82996Z"
          />
        </g>
      </g>
    </svg>
  ),
  ContabilIcon: (fill) => <QSCIcon fill={fill} />,
  EscritaIcon: (fill) => (
    <svg
      id="uuid-42c22d6c-3192-4c49-8c00-af705928d26f"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16.60572 20.23275"
      width={18}
      height={18}
      fill={fill}
    >
      <defs>
        <style></style>
      </defs>
      <g id="uuid-9827b73e-643f-4b44-8ceb-1e1b08c63a0c">
        <g id="uuid-6b187edd-e6b1-484d-8abf-7efbe55a568e">
          <g id="uuid-755cdc52-987d-4267-b863-f0227e79309b">
            <path
              id="uuid-2f4a90d0-a770-4b74-8e33-267a5dc0d2d7"
              style={{
                fill: "none",
                stroke: fill,
                strokeLinecap: "round",
                strokeWidth: "1.5px",
              }}
              class="uuid-cdd857da-085b-484d-b11d-f5fbd08b2604"
              d="m15.85467,17.85604c-.032.10599-.064.21201-.1.31699-.2122.72089-.86481,1.22287-1.616,1.24301-2.48067.01132-4.96167.01132-7.443,0-.6906-.13004-1.2213-.6861-1.319-1.38199-.03-.63901-.027-1.28-.048-1.92001-.006-.20001.049-.26901.262-.26901,2.783.00699,5.567,0,8.35.00601.92527-.06226,1.74219.59906,1.874,1.517.00903.02411.02113.04697.036.06799l.00399.42001Z"
            />
            <path
              id="uuid-d9a5f175-abb5-4e63-9073-18e5c2d212fd"
              style={{
                fill: "none",
                stroke: fill,
                strokeLinecap: "round",
                strokeWidth: "1.5px",
              }}
              class="uuid-cdd857da-085b-484d-b11d-f5fbd08b2604"
              d="m15.85567,2.74705c-.034.115-.065.23-.1.344-.21857.68617-.83189,1.17089-1.55,1.225-.12.009-.242.011-.362.011H5.36467v-1.027c0-.335-.007-.657.006-.985.02516-.84291.70401-1.51957,1.547-1.542,2.4-.014,4.8-.014,7.2,0,.82845.0109,1.53387.60539,1.685,1.42.01335.04831.02972.09574.049.142v.415"
            />
            <path
              id="uuid-029ee5a7-ce59-4d3f-a98e-b831369e8a39"
              style={{
                fill: "none",
                stroke: fill,
                strokeLinecap: "round",
                strokeWidth: "1.5px",
              }}
              class="uuid-cdd857da-085b-484d-b11d-f5fbd08b2604"
              d="m5.65167.75005c-.32437.33981-.5516.76044-.658,1.218-.03375.21328-.04881.4291-.045.645,0,4.886,0,9.773-.008,14.659-.11718.81723.18102,1.63906.795,2.191-.155.008-.238.016-.32.016h-2.359c-1.1948.06921-2.21948-.84326-2.28869-2.03806-.00505-.08725-.00482-.17472.00068-.26194-.00667-3.96267-.01233-7.92467-.017-11.886-.06192-2.26212,1.60028-4.20316,3.845-4.49.35047-.03647.70264-.05416,1.055-.053"
            />
            <path
              id="uuid-499222ba-8c4a-412a-b5fd-344f784dbe30"
              style={{
                fill: "none",
                stroke: fill,
                strokeLinecap: "round",
                strokeWidth: "1.5px",
              }}
              class="uuid-cdd857da-085b-484d-b11d-f5fbd08b2604"
              d="m5.37767,12.00806v-3.547c.061-.006.11-.015.16-.015,1.521,0,3.042-.007,4.563,0,.8662-.02657,1.62311.58066,1.785,1.43201.19183.97824-.44568,1.92677-1.42392,2.11861-.07335.01439-.14751.0242-.22208.02939-1.6.03-3.2.007-4.8.005-.02302-.00534-.04522-.01375-.066-.02499"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  FolhaIcon: (fill) => (
    <svg
      fill={fill}
      width={18}
      height={18}
      id="uuid-92e0d73a-0cdf-4191-bb13-990da2d12db8"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 17.02776 20.69519"
    >
      <defs></defs>
      <g id="uuid-a096a17b-fef8-42a1-9eac-911c5cce587d">
        <g id="uuid-f2dad107-b6ee-44c9-ac6b-e6b8a4d70ade">
          <g id="uuid-0a64649b-0100-4655-b757-ce42e9bec7cf">
            <path
              id="uuid-5211999d-897f-42a8-8cb3-36abf9129880"
              style={{
                fill: "none",
                stroke: fill,
                strokeWidth: "1.5px",
              }}
              class="uuid-8ea5c1fe-b6aa-41c7-8851-84c202391648"
              d="m5.88352.75c-.3852.32072-.65347.75987-.763,1.249-.03383.219-.04955.44042-.047.662v14.979c.05591,1.00471-.5822,1.91747-1.545,2.21-1.12687.34714-2.32179-.28496-2.66893-1.41183-.05795-.18813-.08961-.38337-.09407-.58017-.024-2.194-.013-4.389-.013-6.583,0-1.972,0-3.945.006-5.917-.02954-2.13331,1.43663-3.99677,3.517-4.47.231-.057.468-.093.7-.138h.908Z"
            />
            <path
              id="uuid-b293f80e-c404-46e9-9eca-a7e385df9908"
              style={{
                fill: "none",
                stroke: fill,
                strokeWidth: "1.5px",
              }}
              class="uuid-8ea5c1fe-b6aa-41c7-8851-84c202391648"
              d="m16.27752,2.83c-.021.065-.047.13-.064.2-.18945.81019-.90605,1.38743-1.738,1.4-2.949.011-5.9,0-8.847,0-.03556-.00226-.07095-.0066-.106-.013-.03561-.76374-.03027-1.52883.01601-2.292.08598-.66051.58585-1.19143,1.24-1.317.058-.017.114-.039.172-.058h7.728c.057.019.113.042.171.057.60658.14307,1.0989.58455,1.307,1.172.047.121.08.247.12.371l.001.48Z"
            />
            <path
              id="uuid-c9b0a509-3c4d-40b8-8a43-cf30f589072b"
              style={{
                fill: "none",
                stroke: fill,
                strokeWidth: "1.5px",
              }}
              class="uuid-8ea5c1fe-b6aa-41c7-8851-84c202391648"
              d="m5.51352,8.64401h3.119c.6,0,1.207-.01199,1.81.005,1.01871.02254,1.82629.86664,1.80375,1.88535-.01868.84488-.60899,1.56905-1.43275,1.75766-.16439.03438-.33208.05048-.5.048-1.52666.00334-3.053.00334-4.579,0-.068,0-.137-.00999-.219-.01601l-.002-3.68001Z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  CndIcon: (fill) => (
    <svg
      width={22}
      height={22}
      fill={fill}
      id="uuid-7a341ba7-a695-4ac5-84fc-5426004871a7"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20.6832 23.92188"
    >
      <path
        fill={fill}
        d="M9.5 11.043a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2h-6a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6Z"
      />
      <path
        fill={fill}
        fill-rule="evenodd"
        d="M4 1.043a1.5 1.5 0 0 0-1.5 1.5v16.5a1 1 0 0 0 1 1h2v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-17a1 1 0 0 0-1-1h-2v-2a1 1 0 0 0-1-1H4Zm12.5 3v-1h-12v15h1v-13a1 1 0 0 1 1-1h10Zm-9 17h12v-15h-12v15Z"
        clip-rule="evenodd"
      />
    </svg>
  ),
  CrmIcon: (fill) => (
    <svg
      fill={fill}
      width={22}
      height={25}
      id="uuid-b0dcca5e-23ee-46db-9ae9-a042079dc6a7"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24.8776 22.82559"
    >
      <defs></defs>
      <g id="uuid-828b5fd0-5891-4a57-8475-161376baa31a">
        <path
          class="uuid-966f5381-024b-4a46-ae15-48da6077607c"
          d="m24.16113,11.7543c.7207-.7002.92285-1.80469.49121-2.71094-.39648-.95898-1.36719-1.54688-2.37988-1.46387-1.41113.0127-2.82227.01758-4.2334.01758-.69824-.00098-.89355-.19434-.90723-.89648-.00879-.39844-.0127-.79785-.01758-1.19629-.00879-.81836-.01855-1.66504-.06152-2.49023-.00879-1.0127-.52441-1.93945-1.38379-2.48242-.95605-.5752-2.10645-.68945-3.146-.31445-.53174.15625-.89453.65234-.88184,1.20508l.00879.52344c.00879.48242.01758.96484.01758,1.44629-.00293.46387-.01172,1.01172-.05811,1.57715.01221.29102-.12061.56836-.34326.7334-1.50244.90039-2.62012,2.31738-3.14111,3.97363-.14258.32617-.32422.63477-.54492.92578-.02393.03613-.0625.06055-.08887.06641-.22461.00879-.4502.00586-.68066.00684l-.11523-.00098v-.22461c0-.89551-.1958-1.08887-1.10205-1.08887H1.04541c-.60986,0-.83105.02637-1.03467.53711l-.01074,12.00977.01074.05566c.16162.40234.36572.53125.83936.53125h4.854c.75195,0,.98096-.22754.98096-.97168v-9.40723c.04932-.00098.09717-.00293.14453-.00391.16797-.00586.32715-.00879.48291.00488.47266.04004.92773-.14844,1.24463-.49121.43994-.43164.76465-.97266.93896-1.56445.37744-1.24805,1.19727-2.3125,2.30518-2.99414.7793-.45312,1.25342-1.29297,1.23779-2.18457.02539-.6709.02637-1.35156.02734-2.01074.00049-.41797.00146-.83496.00635-1.23438.00635-.04297.03076-.08105.06738-.10449.22412-.03906.45166-.05664.6958-.05566.07617-.00586.15283-.00586.22852,0,.91504.0625,1.60938.8584,1.54688,1.78711l.01855,1.15723c.0127.83496.02539,1.66992.04395,2.50488.00586.21484.03906.42578.09961.63086.30859.95312,1.22754,1.56348,2.20996,1.50391l4.30371-.0293c.05469-.00586.10938-.00586.16602,0,.26855.02246.51172.14746.68457.35254.17383.20605.25781.4668.23535.73438-.02246.26855-.14746.51172-.35254.68457-.20605.17383-.4707.25391-.73438.23535-.21484-.01758-.42969-.00488-.6416.04199-.34863.08203-.5752.41113-.52734.76562.04688.3457.3457.61133.69727.61621l.50977-.00098c.00781-.00098.01465-.00098.02246-.00098.56152,0,1.02441.45117,1.03613,1.0127l-.00098.0498c-.03125.55762-.52051.98926-1.07812.95605-.10938.00293-.21875.00098-.32812.00098-.20117,0-.39844-.00098-.58496.00977h-.00195c-.3916,0-.71387.31738-.71875.71289.00488.39453.31738.71094.70117.71875.16211.01465.32422.0127.4834.01074l.16016-.00098v-.15015h.00006l.0556.14917c.26562.00293.51465.1084.7002.29785.18555.19043.28613.44043.28223.74121-.00879.26855-.12305.51855-.32031.70215-.1875.1748-.43066.27051-.69141.27051-.11719,0-.25684-.00098-.3877-.00293-.23633-.00391-.47461-.00586-.70703.00195-.05078,0-.10156.00586-.15332.01758-.18555.04297-.34277.1543-.44434.31543-.10059.16113-.13281.35156-.08984.53906.08203.33398.37598.56348.71973.56348.00684,0,.01367,0,.01953-.00098.26074-.00879.52246-.00195.7666.02539.51367.09473.86035.57422.78906,1.09961-.04395.49805-.46289.87988-.96387.87988-.00977,0-.01953,0-.0293-.00098h-10.01318c-.1123,0-.22363-.0127-.33447-.04004-.57812-.12988-1.08789-.49414-1.39502-.99219-.28418-.51465-.86377-.78809-1.43262-.68848-.37061.04297-.65332.35742-.65771.73633.01025.38184.31787.68555.70703.69238.00293-.00098.00537-.00098.0083-.00098.09863,0,.19141.05664.24609.15918.66748.99121,1.77197,1.57812,2.96094,1.57812h.05518l8.57129.00098c.15332,0,.30859.00098.46387.00098.34766,0,.7002-.00293,1.05273-.01562,1.33203-.12109,2.32715-1.30469,2.21777-2.64355-.05664-.46777-.2334-.90918-.51465-1.28613.0459-.03516.09082-.07324.13477-.11133.48926-.4375.7793-1.03906.81543-1.69336.0332-.60059-.14844-1.17969-.5166-1.64941.10254-.08105.19922-.1709.28906-.26855.88867-.97461.85254-2.47168-.05762-3.40332Zm-18.92871-.93652l-.00098,10.21582H1.45117v-10.21582h3.78125Z"
        />
      </g>
    </svg>
  ),
  XmlIcon: (fill) => <XMLIcon fill={fill} />,
  BankIcon: (fill) => <QyonBankIcon fill={fill} />,
  GuiasIcon: (fill) => (
    <svg
      width={18}
      height={18}
      viewBox="0 0 22 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.50001 0.5C8.79681 0.5 9.07826 0.631825 9.26821 0.859815L11.4684 3.5H18C19.1046 3.5 20 4.39545 20 5.5V7.5H21C21.2996 7.5 21.5834 7.6343 21.7734 7.866C21.9633 8.0977 22.0394 8.40235 21.9806 8.6961L19.9806 18.6961C19.8871 19.1635 19.4767 19.5 19 19.5H1.01211C0.981795 19.5003 0.951246 19.4993 0.920539 19.4968C0.887979 19.4942 0.855698 19.4901 0.8238 19.4844C0.62644 19.4492 0.450624 19.357 0.312623 19.2263C0.290101 19.205 0.268586 19.1826 0.248148 19.1593C0.0930307 18.9824 9.41757e-06 18.751 9.41757e-06 18.5V2.5C9.41757e-06 1.39543 0.89544 0.5 2.00001 0.5H8.50001ZM11 5.5C10.7032 5.5 10.4218 5.3682 10.2318 5.1402L8.03165 2.5H2.00001V10.3769L2.52986 8.25745C2.64116 7.8123 3.04114 7.5 3.50001 7.5H18V5.5H11ZM2.28079 17.5L4.2808 9.5H19.7802L18.1802 17.5H2.28079Z"
        fill={fill}
      />
    </svg>
  ),
  RelatoriosIcon: (fill) => (
    <svg
      width={18}
      height={18}
      enable-background="new 0 0 320 100"
      viewBox="1 3 21 18"
    >
      <path
        fill={fill}
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9H13V4.07c3.61.45 6.48 3.32 6.93 6.93zM4 12c0-4.07 3.06-7.44 7-7.93v15.86c-3.94-.49-7-3.86-7-7.93zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z"
      ></path>
    </svg>
  ),
  AtendimentoIcon: (fill) => <AtendimentoIcon fill={fill} />,
  ConfigIcon: (fill) => (
    <svg
      id="uuid-a2b2a011-f3d2-4168-a122-04919a4d60d5"
      width={20}
      height={20}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 23.412 24.615"
    >
      <defs></defs>
      <g id="uuid-1ba37bb8-6a3c-4402-af87-32f8f7d8ba97">
        <g id="uuid-8d8c0123-725a-4998-810a-9791fc4bab54">
          <g id="uuid-5a30f51c-24f3-42d3-8a25-186aa7105348">
            <path
              id="uuid-25333d3f-c6dc-4c0d-9e89-fd397c6c81e3"
              style={{
                fill: "none",
                stroke: "#063bb5",
              }}
              class="uuid-e790038e-8adb-4102-833d-e644ed7e7e83"
              d="m15.082,12.299c0,1.85899-1.50701,3.366-3.366,3.366s-3.366-1.50701-3.366-3.366,1.50701-3.366,3.366-3.366c1.85899,0,3.366,1.50701,3.366,3.366h0Z"
            />
            <path
              id="uuid-1eb9a94c-8b68-4862-a380-537e04604c1f"
              style={{
                fill: "none",
                stroke: "#063bb5",
                strokeLinejoin: "round",
                strokeWidth: "1.6px",
                strokeLinecap: "square",
              }}
              class="uuid-34b4edf9-3f70-4fc9-ae7d-0b49439214f3"
              d="m20.767,12.3v-.03c-.04054-1.58532.68308-3.09357,1.945-4.054l.1-.075-1.96-3.411c-1.44857.65422-3.12356.57084-4.5-.224l-.224-.135c-1.38245-.78292-2.29725-2.1898-2.452-3.771h-3.935c-.16644,1.5851-1.07772,2.99621-2.454,3.8l-.224.12c-1.37644.79484-3.05142.87822-4.5.224l-1.963,3.411.1.075c1.27708.94847,2.00617,2.46423,1.95,4.054v.06c.04002,1.5869-.68561,3.09621-1.95,4.056l-.1.045,1.96,3.411.1-.045c1.46016-.62866,3.13513-.50588,4.488.329.015.015.03.015.045.03,1.39694.75817,2.33935,2.14682,2.528,3.725l.015.12h3.935l.015-.12c.18865-1.57818,1.13106-2.96683,2.528-3.725.015-.015.03-.015.045-.03,1.3552-.82764,3.02659-.95017,4.488-.329l.1.045,1.96-3.411-.1-.075c-1.2752-.94955-2.00233-2.46513-1.945-4.054l.005-.016Z"
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  SairIcon: (fill) => (
    <svg
      id="uuid-3efa8f9d-e8ff-481d-a331-a9ff35dd3f75"
      width={22}
      height={22}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18.68111 20.26632"
    >
      <g id="uuid-025844d6-6b37-4db9-9f02-4c324a564577">
        <g>
          <path d="m18.68111,17.27273c-.0647.24169-.11402.48878-.19665.72419-.463,1.31904-1.63063,2.19705-3.0233,2.25192-.71146.02803-1.42469.01386-2.13713.01413-2.93697.00109-5.87395-.00231-8.81092.0016-1.34614.00179-2.37888-.55518-3.07468-1.70815-.27742-.4597-.43006-.96754-.43656-1.5081-.00929-.77275-.01044-3.17914-.00588-3.95194.00237-.40117.28717-.69106.6577-.69323.37216-.00218.66167.28187.66734.68374.00956.67722-.0011,2.98816.00503,3.66545.00964,1.06525.56159,1.82913,1.52916,2.09843.21415.0596.44527.08113.66863.08143,3.54521.00488,7.09044.0048,10.63566.00261,1.07803-.00066,1.85642-.57762,2.11991-1.57268.04598-.17365.06064-.36012.06078-.54069.00324-4.45488.00654-8.90976-.00039-13.36463-.0016-1.03187-.56961-1.77965-1.52508-2.04361-.21427-.0592-.44554-.07919-.66903-.0795-3.53653-.00475-7.07306-.0043-10.60959-.00276-1.096.00048-1.8801.57758-2.13656,1.58351-.05279.20707-.06066.4292-.06335.64471-.00812.6512.00299,2.52775-.00618,3.17892-.00602.42688-.28472.71551-.66432.71626-.30532.0006-.64683-.2333-.64696-.53108-.00047-1.08159-.16071-3.40134.11286-4.46654C1.48427,1.08359,2.76181.06888,4.17392.01993,5.07656-.01136,5.98091.00368,6.88449.00318c2.7545-.00153,5.509.00301,8.26349-.00202,1.35703-.00248,2.4095.55095,3.08401,1.7281.21879.38182.30323.84053.44912,1.26408,0,4.7598,0,9.5196,0,14.2794Z" />
          <path d="m11.09764,10.60177h-.35065c-3.98004,0-5.91826.00004-9.8983-.00005-.57001-.00001-.85481-.24998-.84859-.68189.00609-.42285.28446-.66331.84109-.66332,3.97135-.00011,5.90088-.00006,9.87223-.00006h.37564c-.09969-.10434-.1599-.16992-.2228-.23282-1.03209-1.03193-2.06715-2.06093-3.09327-3.09874-.11684-.11817-.21675-.27499-.26681-.43224-.08266-.25959.04262-.52903.26634-.68069.20944-.14198.52661-.14577.73762.00109.08474.05898.15946.13383.23298.20722,1.43266,1.42994,2.86459,2.86061,4.29637,4.29143.44341.44311.44561.78296.00718,1.22129-1.44376,1.44342-2.88896,2.88539-4.33069,4.33082-.16645.16687-.34433.29163-.58996.2839-.26626-.00838-.47363-.12485-.58371-.36787-.10725-.23677-.09102-.47599.0738-.68834.06355-.08187.14053-.1537.2142-.2273,1.06912-1.06807,2.13871-2.13566,3.26734-3.26242Z" />
        </g>
      </g>
    </svg>
  ),
  QuizIcon: (fill) => (
    <svg
      id="uuid-2a5a17eb-b4b1-4045-a9e5-915ff23ad6d4"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.27499 24.94969"
      fill={fill}
      width={22}
      height={22}
    >
      <g id="uuid-b17127fc-4cea-47a2-a081-eaa679d2f560">
        <g>
          <path d="m9.97327,23.73777c.50195-.64551.71973-1.45312.61328-2.27344-.19727-1.51758-1.51172-2.65234-3.06641-2.65234-.01074,0-.02246,0-.0332.00098-1.48145.01562-2.80957,1.21582-2.95996,2.67676-.16504,1.59082.81543,3,2.33008,3.34961.12109.02832.24219.05176.36426.0752l.17773.03516.34668-.00977c.05371-.0166.10645-.03223.16113-.03809.82812-.10156,1.56152-.51465,2.06641-1.16406Zm-1.09277-.54688c-.35645.35547-.82715.55176-1.3252.55176h-.00586c-1.02344-.00391-1.86133-.8418-1.86816-1.86914-.00195-.49805.19336-.96875.5498-1.3252.35645-.35547.82617-.55176,1.3252-.55176h.01172c1.02734.00586,1.86523.8418,1.86621,1.86523,0,.5-.19629.97266-.55371,1.3291Z" />
          <path d="m15.07971,6.03367C14.14807,2.02879,10.50647-.47512,6.43421.07566,3.32385.49754.69202,2.94969.03186,6.03953c-.08496.39746.00195.81152.2373,1.13477.2334.32031.58008.51855.97559.55859.6084.06152,1.2373.11426,1.87012.15918.6875.05469,1.24219-.32031,1.47754-.9834l.03906-.11426c.02148-.06348.04199-.12598.06543-.18945.57129-1.50488,2.21777-2.30371,3.75879-1.80859,1.55371.49609,2.45312,2.10742,2.04883,3.66797-.35254,1.35059-1.49219,2.25195-2.90527,2.29688-1.44336.04395-2.37793,1.00195-2.37988,2.43945l-.00098.9082.00098.30371h.00098l-.00195.65527c-.00195.37109-.00391.74316.00391,1.11523.01367.69141.50977,1.24512,1.15234,1.28906.75391.04883,1.54297.04883,2.34961-.00098.57812-.03613,1.05176-.51465,1.12598-1.1377.03125-.26172.03906-.54492.02344-.84277-.01758-.29102.09277-.45508.37988-.56348,3.61523-1.36426,5.69043-5.1875,4.82617-8.89355Zm-5.74023,7.95801c-.53711.14941-.63867.2832-.63867.84375-.00098.41602-.00293.83203-.00586,1.24707,0,.03809-.0127.06934-.02051.0918l-.03711.0957-.11523.0332h-2.10547v-1.54297c0-.52832-.00098-1.05762,0-1.58496.00391-.74609.42773-1.19434,1.16406-1.23145,1.72168-.08789,2.97754-.86621,3.7334-2.31445.54102-1.03516.62012-2.2168.22461-3.32617-.39941-1.11914-1.25781-2.03027-2.35449-2.49902-1.08398-.46387-2.27441-.4541-3.35059.02832-1.08301.48438-1.8877,1.37402-2.26758,2.50488-.09668.28809-.25391.38867-.54492.3623-.3916-.04199-.78418-.07227-1.19336-.10352l-.65625-.05176.03027-.16309c.1416-.75781.41895-1.45801.8457-2.14062C3.52307,1.88621,6.31213.7114,8.98792,1.32566c2.76465.63379,4.75684,2.85547,5.07617,5.66016.35742,3.14746-1.67285,6.15918-4.72461,7.00586Z" />
        </g>
      </g>
    </svg>
  ),
  DocumentosIcon: (fill) => (
    <svg
      id="Grupo_2268"
      data-name="Grupo 2268"
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      viewBox="0 0 16.561 15.759"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Retângulo_527"
            data-name="Retângulo 527"
            width="16.561"
            height="15.759"
            fill={fill}
          />
        </clipPath>
      </defs>
      <g id="Grupo_2267" data-name="Grupo 2267" clip-path="url(#clip-path)">
        <path
          id="Caminho_2776"
          data-name="Caminho 2776"
          d="M.033,4.319c.99,0,1.957,0,2.923,0,.922,0,1.348-.42,1.352-1.338,0-.979,0-1.958,0-2.959C4.453.014,4.567,0,4.682,0q2.768,0,5.535,0A1.131,1.131,0,0,1,11.48,1.259q.01,2.08,0,4.161a1.311,1.311,0,0,1-.109.488c-.406.961-.841,1.911-1.226,2.88a1.316,1.316,0,0,0-.034.782c.165.6.411,1.182.6,1.78.125.4.317.713.777.781,0,.844.019,1.668-.006,2.491a1.089,1.089,0,0,1-1.156,1.127q-4.593.018-9.186,0a1.042,1.042,0,0,1-1.127-1.1C0,11.263,0,7.874,0,4.485a1.212,1.212,0,0,1,.031-.166M5.719,5.508c-1.021,0-2.042,0-3.063,0-.276,0-.517.056-.513.391,0,.31.236.376.493.376H8.8c.273,0,.523-.063.514-.4s-.26-.374-.533-.373c-1.021,0-2.042,0-3.062,0m-.04,2.6c1.046,0,2.091,0,3.137,0,.264,0,.49-.049.5-.358s-.214-.379-.479-.379q-3.1,0-6.2,0c-.255,0-.495.039-.5.358,0,.34.242.379.516.378,1.006,0,2.013,0,3.019,0M4.454,12.165c.364.864.622,1.033,1.557,1.033.222,0,.444-.007.666,0,.262.01.458-.1.467-.361.01-.285-.2-.4-.472-.4s-.549-.014-.823,0a.514.514,0,0,1-.626-.52.629.629,0,0,0-1.056-.467c-.493.319-.974.656-1.464.978-.236.155-.387.344-.2.61.179.25.395.167.613.015.438-.3.886-.593,1.333-.89m.177-2.2c.654,0,1.308,0,1.963,0,.275,0,.521-.057.519-.388S6.863,9.2,6.588,9.2q-1.963,0-3.925,0c-.272,0-.52.052-.518.388s.254.383.523.383H4.631m4,3.229c.26-.016.619.089.667-.362.031-.288-.182-.4-.7-.4-.3,0-.682-.038-.691.373-.009.455.393.386.727.39"
          transform="translate(0 0)"
          fill={fill}
        />
        <path
          id="Caminho_2777"
          data-name="Caminho 2777"
          d="M144.62,50.346,141.8,49.127l2.108-4.879,2.82,1.218-2.109,4.879"
          transform="translate(-130.664 -40.773)"
          fill={fill}
        />
        <path
          id="Caminho_2778"
          data-name="Caminho 2778"
          d="M3.392,6.422l3.291-3.3c0,.225,0,.4,0,.566q0,1.135,0,2.271c0,.248-.07.457-.359.46-.961.009-1.922,0-2.932,0"
          transform="translate(-3.126 -2.877)"
          fill={fill}
        />
        <path
          id="Caminho_2779"
          data-name="Caminho 2779"
          d="M175.422,23.812l-2.8-1.215a1.492,1.492,0,0,1,1.166-1.06,1.449,1.449,0,0,1,1.526.568,1.549,1.549,0,0,1,.11,1.708"
          transform="translate(-159.063 -19.811)"
          fill={fill}
        />
        <path
          id="Caminho_2780"
          data-name="Caminho 2780"
          d="M137.6,117.608l-.762-2.242.1-.069,2.772,1.195.033.119c-.677.372-1.407.64-2.146,1"
          transform="translate(-126.088 -106.242)"
          fill={fill}
        />
      </g>
    </svg>
  ),
  ReportsIcon: (fill) => (
    <svg
      id="uuid-dda02d46-dc9f-4d57-bb26-1260af87b7d0"
      fill={fill}
      width={30}
      height={20}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <defs>
        <style></style>
      </defs>
      <g id="uuid-27e1aded-ccd0-4a77-9af1-a7a71a7940af">
        <g id="uuid-2b4c0d7f-26fe-4e26-b85e-a4c54b902a4d">
          <g id="uuid-4085a58d-6d98-4b04-bdc1-4b1c4e15eb11">
            <path
              class="uuid-3847c459-b641-4e60-970f-35b1c6eca982"
              d="M21.0963 7.00111C19.8323 7.00111 18.8087 8.02581 18.8087 9.28868C18.8087 9.71296 18.9262 10.1096 19.1278 10.4496L16.7627 12.7682C16.4137 12.5522 16.0027 12.4248 15.5618 12.4248C15.0378 12.4248 14.556 12.6032 14.1705 12.9001L10.8438 10.2436C10.9778 9.95225 11.0554 9.62988 11.0554 9.28758C11.0554 8.02359 10.0307 7 8.76778 7C7.50491 7 6.48021 8.0247 6.48021 9.28758C6.48021 9.71629 6.59985 10.1162 6.80479 10.4585L4.47844 12.7616C4.13171 12.5489 3.72404 12.4248 3.28758 12.4248C2.02359 12.4248 1 13.4495 1 14.7124C1 15.9753 2.0247 17 3.28758 17C4.55045 17 5.57515 15.9753 5.57515 14.7124C5.57515 14.2837 5.45551 13.8838 5.25057 13.5415L7.57692 11.2384C7.92365 11.4511 8.33132 11.5752 8.76778 11.5752C9.29177 11.5752 9.77365 11.3968 10.1592 11.0999L13.4858 13.7564C13.3518 14.0477 13.2743 14.3701 13.2743 14.7124C13.2743 15.9764 14.299 17 15.5618 17C16.8247 17 17.8494 15.9753 17.8494 14.7124C17.8494 14.2881 17.732 13.8915 17.5304 13.5514L19.8955 11.2328C20.2444 11.4489 20.6554 11.5763 21.0963 11.5763C22.3603 11.5763 23.3839 10.5516 23.3839 9.28868C23.3839 8.02581 22.3592 7.00111 21.0963 7.00111Z"
              fill={fill}
            />
          </g>
        </g>
      </g>
    </svg>
  ),
  NewContabilIcon: (fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill={fill}
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="m18.074 5.86-1.49 2.282c-.121.143-.253.214-.396.214a.545.545 0 0 1-.29-.085c-.593-.408-1.325-.611-2.197-.611-1.2 0-2.207.425-3.021 1.275-.808.85-1.211 1.872-1.211 3.065 0 1.207.403 2.236 1.21 3.086.808.843 1.815 1.265 3.022 1.265.872 0 1.633-.222 2.283-.665a.444.444 0 0 1 .268-.085c.136 0 .246.075.332.225l1.49 2.25c.164.272.128.479-.107.622-1.3.8-2.722 1.2-4.265 1.2-1.122 0-2.172-.2-3.151-.6a7.574 7.574 0 0 1-2.508-1.661 7.76 7.76 0 0 1-1.629-2.508A8.32 8.32 0 0 1 5.825 12c0-1.093.196-2.125.59-3.097.4-.979.942-1.818 1.628-2.518a7.574 7.574 0 0 1 2.508-1.661 7.997 7.997 0 0 1 3.15-.622c1.565 0 2.965.386 4.201 1.157.236.122.293.322.172.6Z"
      />
    </svg>
  ),
  NewFolhaIcon: (fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill={fill}
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M10.092 19.684H7.263c-.278 0-.418-.14-.418-.418V4.734c0-.278.14-.418.418-.418h9.474c.278 0 .418.14.418.418v2.744c0 .264-.14.396-.418.396h-6.248v2.904h5.38c.143 0 .246.032.31.097.065.064.097.168.097.31v2.637c0 .278-.136.418-.407.418h-5.38v5.026c0 .278-.132.418-.397.418Z"
      />
    </svg>
  ),
  NewEscritaIcon: (fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={18}
      height={18}
      fill={fill}
      viewBox="0 0 24 24"
    >
      <path
        fill={fill}
        d="M1.066 4.316h8.841c.264 0 .397.14.397.418v2.744c0 .264-.133.396-.397.396H4.292v2.39h4.844c.264 0 .396.14.396.418v2.636c0 .279-.132.418-.396.418H4.292v2.39h5.637c.278 0 .418.132.418.396v2.744c0 .278-.14.418-.418.418H1.066c-.278 0-.418-.14-.418-.418V4.734c0-.278.14-.418.418-.418ZM16.29 19.684h-2.83c-.278 0-.417-.14-.417-.418V4.734c0-.278.14-.418.418-.418h9.473c.279 0 .418.14.418.418v2.744c0 .264-.14.396-.418.396h-6.248v2.904h5.38c.143 0 .246.032.31.097.065.064.097.168.097.31v2.637c0 .278-.136.418-.407.418h-5.38v5.026c0 .278-.132.418-.396.418Z"
      />
    </svg>
  ),
  BotIcon: (fill) => (
    <svg
      width="40"
      height="34"
      viewBox="0 0 40 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6773 0.328416C7.85325 0.696207 5.41986 1.94826 3.42111 4.06144C0.605904 7.03833 -0.415644 10.4355 0.150071 14.9397C0.754588 19.7549 2.46608 21.8146 11.5769 28.6921C15.1293 31.3736 18.116 33.5676 18.2145 33.5676V24.9926C19.4059 24.9728 20.4791 24.9579 21.4515 24.9445L21.452 24.9445C28.0088 24.8539 29.9839 24.8266 32.7398 23.75C37.872 21.3147 40.712 16.0173 39.846 10.4955C39.4309 7.84826 38.5581 6.10483 36.6258 4.06144C34.5592 1.87653 32.2335 0.72164 29.0733 0.311135C26.2535 -0.0550264 13.5287 -0.0432886 10.6773 0.328416ZM10.3379 8.84623C10.3379 8.12592 10.9218 7.54199 11.6421 7.54199H14.2506C14.9709 7.54199 15.5548 8.12592 15.5548 8.84623V15.3673C15.5548 16.0876 14.9709 16.6716 14.2506 16.6716H11.6421C10.9218 16.6716 10.3379 16.0876 10.3379 15.3673V8.84623ZM25.9878 7.54199C25.2675 7.54199 24.6836 8.12592 24.6836 8.84623V15.3673C24.6836 16.0876 25.2675 16.6716 25.9878 16.6716H28.5963C29.3166 16.6716 29.9005 16.0876 29.9005 15.3673V8.84623C29.9005 8.12592 29.3166 7.54199 28.5963 7.54199H25.9878Z"
        fill="url(#paint0_linear_3744_36087)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3744_36087"
          x1="0"
          y1="0.0429688"
          x2="33.0086"
          y2="39.4273"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#007FFF" />
          <stop offset="1" stop-color="#0059B2" />
        </linearGradient>
      </defs>
    </svg>
  ),

  SupportIcon: (fill) => (
    <svg
      version="1.1"
      id="Camada_1"
      width={18}
      height={18}
      fill={fill}
      viewBox="0 0 24 24"
    >
      <defs>
        <filter
          id="Adobe_OpacityMaskFilter"
          filterUnits="userSpaceOnUse"
          x="3"
          y="1.5"
          width="18"
          height="21"
        >
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
          />
        </filter>
      </defs>
      <mask
        maskUnits="userSpaceOnUse"
        x="3"
        y="1.5"
        width="18"
        height="21"
        id="mask0_2975_21876_00000008829666448587233450000006467163014491109013_"
      >
        <rect y="-0.5" class="st0" width="24" height="24" />
      </mask>
      <g class="st1">
        <path
          d="M12,22.5v-2h7v-1h-4v-8h4v-1c0-1.9-0.7-3.6-2-4.9c-1.4-1.4-3-2-5-2s-3.6,0.7-4.9,2S5,8.6,5,10.5v1h4v8H5
		c-0.6,0-1-0.2-1.4-0.6C3.2,18.6,3,18.1,3,17.5v-7c0-1.2,0.2-2.4,0.7-3.5s1.1-2,1.9-2.9s1.8-1.5,2.9-1.9s2.3-0.7,3.5-0.7
		s2.4,0.2,3.5,0.7s2,1.1,2.9,1.9s1.5,1.8,1.9,2.9S21,9.3,21,10.5v10c0,0.6-0.2,1-0.6,1.4c-0.4,0.4-0.9,0.6-1.4,0.6H12z M5,17.5h2v-4
		H5V17.5z M17,17.5h2v-4h-2V17.5z"
        />
      </g>
    </svg>
  ),

  ChatIcon: (fill) => (
    <svg
      version="1.1"
      id="Camada_1"
      viewBox="0 0 24 24"
      width={18}
      height={18}
      fill={fill}
    >
      <path d="M7,8C6.4,8,6,8.5,6,9c0,0.6,0.4,1,1,1h9c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H7z" />
      <path d="M6,13c0-0.6,0.4-1,1-1h9c0.6,0,1,0.4,1,1c0,0.6-0.4,1-1,1H7C6.4,14,6,13.6,6,13z" />
      <path d="M7,16c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h5c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H7z" />
      <path
        class="st0"
        d="M1,12v10c0,0.6,0.4,1,1,1h10c6.1,0,11-4.9,11-11C23,6,18.1,1,12,1C5.9,1,1,6,1,12z M3,12c0-5,4-9,9-9
	c5,0,9,4,9,9c0,5-4,9-9,9H3V12z"
      />
    </svg>
  ),

  BillToPayIcon: (fill) => (
    <svg
      width={24}
      height={25}
      viewBox="0 0 24 25"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 3.043a2 2 0 012-2h14a2 2 0 012 2v11.5a1 1 0 11-2 0v-11.5H5v16h9.5a1 1 0 110 2H5a2 2 0 01-2-2v-16z" />
      <path d="M7.5 6.043a1 1 0 011-1h7a1 1 0 110 2h-7a1 1 0 01-1-1zM8.5 9.043a1 1 0 000 2h7a1 1 0 100-2h-7zM7.5 14.043a1 1 0 011-1h3a1 1 0 110 2h-3a1 1 0 01-1-1zM16.5 16.543a1 1 0 011.415 0l2.5 2.5a1 1 0 010 1.414l-2.5 2.5a1 1 0 01-1.414-1.414l1.793-1.793-1.793-1.793a1 1 0 010-1.414z" />
    </svg>
  ),
  RadarIcon: (fill) => <RadarIcon fill={fill} />,
  KnowledgeBaseIcon: (fill) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 3.5C1 2.94772 1.44772 2.5 2 2.5H8C9.6356 2.5 11.0878 3.28534 12 4.49951C12.9122 3.28534 14.3644 2.5 16 2.5H22C22.5523 2.5 23 2.94772 23 3.5V18.5C23 19.0523 22.5523 19.5 22 19.5H15C13.8954 19.5 13 20.3954 13 21.5C13 22.0523 12.5523 22.5 12 22.5C11.4477 22.5 11 22.0523 11 21.5C11 20.3954 10.1046 19.5 9 19.5H2C1.44772 19.5 1 19.0523 1 18.5V3.5ZM11 18.0351C10.4117 17.6948 9.72857 17.5 9 17.5H3V4.5H8C9.65687 4.5 11 5.84313 11 7.5V18.0351ZM13 7.5V18.0351C13.5883 17.6948 14.2714 17.5 15 17.5H21V4.5H16C14.3431 4.5 13 5.84313 13 7.5Z"
        fill={fill}
      />
    </svg>
  ),
  WebsiteIcon: (fill) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42 18V40C42 41.1046 41.1046 42 40 42H8C6.89543 42 6 41.1046 6 40V18"
        stroke={fill}
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6 8C6 6.89543 6.89543 6 8 6H40C41.1046 6 42 6.89543 42 8V18H6V8Z"
        fill="none"
        stroke={fill}
        stroke-width="4"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12C16 13.1046 16.8954 14 18 14Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24 14C25.1046 14 26 13.1046 26 12C26 10.8954 25.1046 10 24 10C22.8954 10 22 10.8954 22 12C22 13.1046 22.8954 14 24 14Z"
        fill={fill}
      />
    </svg>
  ),

  PermissionGroupIcon: (fill) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="17"
        y="6"
        width="14"
        height="9"
        fill="none"
        stroke={fill}
        stroke-width="4"
        stroke-linejoin="round"
      />
      <rect
        x="6"
        y="33"
        width="14"
        height="9"
        fill="none"
        stroke={fill}
        stroke-width="4"
        stroke-linejoin="round"
      />
      <rect
        x="28"
        y="33"
        width="14"
        height="9"
        fill="none"
        stroke={fill}
        stroke-width="4"
        stroke-linejoin="round"
      />
      <path
        d="M24 16V24"
        stroke={fill}
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 33V24H35V33"
        stroke={fill}
        stroke-width="4"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  ),

  BackupIcon: (fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M21.98 5.51684V5.07189C21.98 4.69025 21.9167 4.32669 21.7883 3.99388C21.6617 3.6665 21.4699 3.3554 21.2167 3.06962C20.7555 2.55052 20.164 2.10919 19.408 1.72393C18.5253 1.27536 17.5794 0.928086 16.5158 0.662202C15.6205 0.439728 14.6329 0.273325 13.4989 0.155758C13.195 0.125009 12.8875 0.0942609 12.5891 0.0635125C12.4498 0.0490426 12.3105 0.0363815 12.1713 0.0219116C12.1622 0.0219116 12.1532 0.0219116 12.1459 0.0219116H9.84704C9.83076 0.0219116 9.81629 0.0219117 9.80001 0.0255292C9.76022 0.0327641 9.72043 0.0418077 9.68425 0.0490426C9.61552 0.0635124 9.55041 0.0779823 9.49253 0.0815998C7.66752 0.175654 6.03785 0.457816 4.50947 0.942556C3.78236 1.17226 3.20176 1.40197 2.68085 1.66605C2.04055 1.98981 1.50336 2.3606 1.0349 2.80012C0.338538 3.45307 0.00392311 4.22721 0.00754057 5.16956C0.0274366 9.25729 0.0400977 12.9435 0.00030562 16.6496C-0.0069293 17.279 0.114256 17.8271 0.367478 18.3208C0.609848 18.7929 0.967977 19.2053 1.46538 19.5833C2.19249 20.1386 3.04259 20.5709 4.14049 20.9471C5.80091 21.5169 7.63496 21.8424 9.74937 21.9455C10.2034 21.9672 10.6573 21.9781 11.0987 21.9781C12.1333 21.9781 13.1498 21.9166 14.1175 21.7936C15.1376 21.6652 16.1396 21.4662 17.0982 21.2003C17.8489 20.9923 18.4892 20.7608 19.0553 20.4931C19.7354 20.173 20.3142 19.7986 20.8297 19.35C21.6237 18.6591 22.0071 17.8271 21.9999 16.8087C21.9728 13.0448 21.9782 9.2175 21.9818 5.51684H21.98ZM1.54315 14.3543C1.54315 14.0776 1.54315 13.7936 1.54315 13.5114C2.26484 14.0287 3.0643 14.4429 3.97047 14.7721C4.83504 15.0868 5.81176 15.3274 7.04531 15.5336C8.34941 15.7506 9.68787 15.861 11.0245 15.861C12.3612 15.861 12.2725 15.8375 12.8966 15.7904C14.1627 15.6964 15.2533 15.5408 16.23 15.3165C17.4111 15.0452 18.4566 14.669 19.4225 14.1662C19.7589 13.9907 20.0808 13.7791 20.3901 13.5747C20.4064 13.5639 20.4209 13.5548 20.4372 13.544C20.4372 13.8497 20.4372 14.1571 20.4372 14.4556C20.4354 15.2605 20.4335 16.0925 20.4444 16.9136C20.4498 17.3459 20.3087 17.6968 19.9976 18.0206C19.4026 18.6392 18.6429 18.9973 18.0496 19.2397C16.5484 19.8528 14.9006 20.2254 13.0159 20.3738C12.3105 20.4298 11.6105 20.4588 10.9359 20.4588C9.37134 20.4588 7.85382 20.305 6.42492 20.003C5.62727 19.8347 4.99059 19.6593 4.41904 19.4513C3.72267 19.1981 3.12398 18.896 2.5886 18.5288C2.35889 18.3697 2.12376 18.1599 1.85064 17.8669C1.63902 17.639 1.53773 17.355 1.53954 16.9969C1.54677 16.116 1.54677 15.2207 1.54496 14.3543H1.54315ZM19.9795 11.9125C19.3845 12.5184 18.6212 12.8784 18.0225 13.1244C16.4833 13.7574 14.7614 14.1192 12.6035 14.2639C11.9868 14.3055 11.379 14.3272 10.7984 14.3272C9.64627 14.3272 8.53209 14.244 7.48845 14.0794C6.36885 13.9021 5.2818 13.6254 4.25806 13.2528C3.42604 12.9507 2.76224 12.5854 2.22504 12.135C1.72403 11.7135 1.5106 11.2577 1.5323 10.6572C1.56124 9.85236 1.55581 9.03663 1.54858 8.24802C1.54677 7.96586 1.54315 7.67465 1.54315 7.38706C2.37336 7.97671 3.29762 8.43613 4.35392 8.78521C5.33787 9.11078 6.41226 9.33868 7.83935 9.52317C8.91554 9.66426 9.99897 9.7348 11.0571 9.7348C12.7283 9.7348 14.3978 9.55754 16.0184 9.20846C16.8595 9.02758 17.5414 8.83586 18.1672 8.60615C18.9287 8.3276 19.5889 7.9948 20.1876 7.59145C20.2726 7.53357 20.354 7.47569 20.4372 7.4142C20.4372 7.72168 20.4372 8.03097 20.4372 8.33122C20.4354 9.1343 20.4317 9.96631 20.4444 10.7857C20.4516 11.227 20.3033 11.5851 19.9814 11.9143L19.9795 11.9125ZM18.0532 7C17.2827 7.31833 16.476 7.56613 15.5861 7.75604C14.7957 7.92426 13.9565 8.04363 13.0177 8.1196C12.3105 8.17748 11.6069 8.20642 10.9268 8.20642C9.37315 8.20642 7.85924 8.05268 6.42492 7.75062C5.62908 7.58241 4.99059 7.40696 4.41904 7.19896C3.72267 6.94573 3.12398 6.64548 2.5886 6.2765C2.3191 6.09201 2.06588 5.86592 1.85968 5.62355C1.64082 5.36852 1.52868 5.11349 1.52868 4.8675C1.52868 4.61971 1.64082 4.37372 1.8633 4.13497C2.18887 3.78588 2.59764 3.46031 3.0444 3.19623C3.52914 2.90865 4.06272 2.66989 4.67768 2.4637C5.18594 2.29368 5.74484 2.14536 6.43577 2.00066C7.85743 1.70403 9.36411 1.5521 10.916 1.5521C10.9359 1.5521 10.9558 1.5521 10.9757 1.5521C12.2635 1.56114 13.3903 1.63711 14.4195 1.78904C15.6295 1.9663 16.7148 2.24303 17.7403 2.63734C18.2522 2.83449 18.7532 3.12027 19.2362 3.3952C19.3266 3.44765 19.4207 3.5001 19.5129 3.55255C19.6992 3.65746 19.8692 3.8311 20.0266 4.00112C20.3124 4.3086 20.4516 4.59438 20.4498 4.87835C20.4498 5.16232 20.3087 5.44991 20.0212 5.75921C19.4532 6.36875 18.708 6.72869 18.0532 7Z"
        fill={fill}
      />
      <path
        d="M11.5093 11.473C11.3609 11.3428 11.1584 11.2704 10.925 11.2614C10.755 11.2541 10.5814 11.2505 10.4132 11.2451C10.0496 11.2342 9.6734 11.2234 9.30803 11.1981C8.13055 11.113 7.11223 10.9738 6.19521 10.7694C5.10816 10.5288 4.1441 10.196 3.24517 9.7565C3.10589 9.68777 2.96843 9.6534 2.83097 9.6534C2.5488 9.6534 2.31186 9.79991 2.17982 10.0567C2.08396 10.243 2.06587 10.4492 2.12918 10.6355C2.19791 10.8399 2.3607 11.0099 2.58679 11.1167C3.04259 11.3319 3.45498 11.5236 3.8945 11.6828C4.82961 12.021 5.81175 12.2743 6.8988 12.4605C7.82668 12.6179 8.83053 12.7264 9.97003 12.7879C9.97545 12.7879 9.97907 12.7879 9.9845 12.7879C10.0786 12.7879 10.1726 12.7879 10.2667 12.7879C10.3607 12.7879 10.4566 12.7879 10.5506 12.7879C10.6899 12.7879 10.8057 12.7879 10.9124 12.7861C11.4062 12.7789 11.7516 12.466 11.7534 12.0265C11.7534 11.8076 11.6666 11.6104 11.5074 11.4712L11.5093 11.473Z"
        fill={fill}
      />
      <path
        d="M2.58679 17.2465C3.04259 17.4617 3.45498 17.6534 3.89269 17.8108C4.82781 18.149 5.81537 18.404 6.90965 18.5921C7.83392 18.7495 8.84319 18.8598 9.99354 18.9268C9.99897 18.9268 10.0044 18.9268 10.008 18.9268H10.5542C10.6682 18.9268 10.784 18.9268 10.8979 18.9268C11.1403 18.9268 11.3501 18.858 11.5056 18.726C11.6702 18.5867 11.7625 18.3841 11.7643 18.1562C11.7643 17.9283 11.6757 17.7276 11.5147 17.5865C11.3646 17.4581 11.1566 17.3857 10.9124 17.3785C10.7442 17.3731 10.5741 17.3694 10.4095 17.3658C10.0442 17.3586 9.66616 17.3514 9.29899 17.3242C8.12512 17.241 7.10861 17.0999 6.18978 16.8974C5.10454 16.6568 4.14049 16.324 3.24336 15.8845C3.10589 15.8176 2.96662 15.7814 2.83097 15.7814C2.5488 15.7814 2.31186 15.9279 2.17982 16.1865C2.08396 16.3728 2.06587 16.579 2.12918 16.7653C2.19791 16.9697 2.3607 17.1397 2.58498 17.2465H2.58679Z"
        fill={fill}
      />
    </svg>
  ),

  AppStoreIcon: (fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill={fill}
    >
      <path d="M666-440 440-666l226-226 226 226-226 226Zm-546-80v-320h320v320H120Zm400 400v-320h320v320H520Zm-400 0v-320h320v320H120Zm80-480h160v-160H200v160Zm467 48 113-113-113-113-113 113 113 113Zm-67 352h160v-160H600v160Zm-400 0h160v-160H200v160Zm160-400Zm194-65ZM360-360Zm240 0Z" />
    </svg>
  ),
  GFIcon: (fill) => <GFIcon fill={fill} height={25} width={25} />,

  DashboardIcon: (fill) => <DashboardIcon fill={fill} height={20} width={20} />,

  FeedIcon: (fill) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7465 11.6698C15.2183 11.0733 15.5 10.3196 15.5 9.5C15.5 7.567 13.933 6 12 6C10.067 6 8.5 7.567 8.5 9.5C8.5 10.3196 8.78169 11.0733 9.25354 11.6698C7.63516 12.5164 6.5 14.0957 6.5 16C6.5 16.5523 6.94772 17 7.5 17C8.05228 17 8.5 16.5523 8.5 16C8.5 14.4506 9.953 13 12 13C14.047 13 15.5 14.4506 15.5 16C15.5 16.5523 15.9477 17 16.5 17C17.0523 17 17.5 16.5523 17.5 16C17.5 14.0957 16.3648 12.5164 14.7465 11.6698ZM12 8C11.1716 8 10.5 8.67157 10.5 9.5C10.5 10.3284 11.1716 11 12 11C12.8284 11 13.5 10.3284 13.5 9.5C13.5 8.67157 12.8284 8 12 8Z"
        fill={fill}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1 4C1 3.44772 1.44772 3 2 3H22C22.5523 3 23 3.44772 23 4V19C23 19.5523 22.5523 20 22 20H14.9142L12.7071 22.2071C12.3166 22.5976 11.6834 22.5976 11.2929 22.2071L9.08579 20H2C1.44772 20 1 19.5523 1 19V4ZM3 5V18H9.5C9.76522 18 10.0196 18.1054 10.2071 18.2929L12 20.0858L13.7929 18.2929C13.9804 18.1054 14.2348 18 14.5 18H21V5H3Z"
        fill={fill}
      />
    </svg>
  ),
  OfxIcon: (fill) => <OfxIcon fill={fill} height={25} width={25} />,
  ConectaZapIcon: (fill) => (
    <ConectaZapIcon fill={fill} height={25} width={25} />
  ),
  BlogReformaIcon: (fill) => (
    <BlogReformaIcon fill={fill} height={25} width={25}></BlogReformaIcon>
  ),
  CrmVendasIcon: (fill) => <CrmVendasIcon fill={fill} height={25} width={25} />,
};

const IconsMenu = ({ icon, color }) => options[icon](color);
export default IconsMenu;
